import { render, staticRenderFns } from "./NewsTypes.vue?vue&type=template&id=624df6eb&"
import script from "./NewsTypes.vue?vue&type=script&lang=ts&"
export * from "./NewsTypes.vue?vue&type=script&lang=ts&"
import style0 from "./NewsTypes.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports